export default __webpack_public_path__ + "static/media/anjelo.18608777.png";